import { notify } from 'components/Notifier';
import { downloadFile } from 'services/apiOperations';
import { ExpeditionFilters, QueryParams } from 'types';
import { formatFilterAsQueryParams } from 'utils/filters';

export function downloadExpeditions(
  sortingCenterId: string,
  filters: ExpeditionFilters,
  t: (m: string) => string,
  setModalVisible: (isVisible: boolean) => void,
): void {
  let url = `/sorting_centers/${sortingCenterId}/expeditions/report`;

  const params: QueryParams = {
    ...formatExpeditionFilterAsQueryParams(filters, 'expeditionDate'),
    sortingCenter: sortingCenterId,
  };

  const stringParams = new URLSearchParams(params as Record<string, string>);
  if (!!stringParams.toString()) {
    url += '?' + stringParams.toString();
  }
  setModalVisible(true);
  downloadFile(url)
    .then(() => {
      setModalVisible(false);
      notify({
        message: t('expeditions.exportPage.success'),
        severity: 'success',
      });
    })
    .catch(() => {
      setModalVisible(false);
    });
}

export function formatExpeditionFilterAsQueryParams(
  filters: ExpeditionFilters | null | undefined,
  dateAttribute: string,
): QueryParams {
  const params: QueryParams = formatFilterAsQueryParams(filters, dateAttribute);

  if (filters?.invalidOnly) {
    params['exists[expeditionBuyerConfirmation]'] = 'false';
  }

  if (undefined !== filters?.isMiseEnCoherenceAccepted) {
    if (null === filters.isMiseEnCoherenceAccepted) {
      params['exists[expeditionBuyerConfirmation]'] = 'true';
      params['exists[isMiseEnCoherenceAccepted]'] = 'false';
    } else {
      params['isMiseEnCoherenceAccepted'] = filters.isMiseEnCoherenceAccepted.toString();
    }
  }

  return params;
}
